let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d4ioj")).then(() => parcelRequire('6P642'));